<template>
  <div
    class="poster-fixed"
    @click.stop="bindStop"
    v-show="value"
    :style="{ zIndex: defaultIndex + zIndex }"
  >
    <div
      class="poster-wrap"
      @click.stop="bindCatch"
      :class="{ 'scale-animation': hasAnimation }"
    >
      <img
        class="title"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/babc5172df2d708590d2c1a2289f1216.png"
        alt=""
      />
      <div class="poster-mask">
        <div class="poster-container" ref="poster" id="poster">
          <div class="poster-content">
            <img
              class="bg"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8c9a29e48e100406992e1f433ccb8b1f.png"
            />
            <div class="user">
              <img
                class="avatar"
                :src="
                  (data.userDetail && data.userDetail.head_img) || defaultAvatar
                "
                alt=""
              />
              <div class="user-right">
                <div class="nickname">
                  {{ data.userDetail && data.userDetail.truename }}
                </div>
                <div class="time">
                  {{ curTime | filterTime }} 在用 吨吨桶 喝水打卡
                </div>
              </div>
            </div>
            <div class="bottom">
              <div class="bottom-right">
                <div class="num">{{ data.totalDay }}</div>
                <div class="text">已坚持天数</div>
              </div>
              <div class="bottom-left">
                <div class="num">{{ data.waterTotal }}</div>
                <div class="text">今日已喝水(ml)</div>
              </div>
            </div>
          </div>
          <!-- 二维码 -->
          <div class="poster-bottom">
            <div class="desc" v-if="data.text">"{{ data.text }}"</div>
            <div class="qrcode-content">
              <img
                class="logo"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
                alt=""
              />
              <div class="center">
                <div class="text">下载betterWE App</div>
                <div class="text">好好喝水 真的能变美</div>
              </div>
              <img
                class="qrcode"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_download_app"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="share-btn" @click="bindShare">立即分享给朋友</div>
    </div>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
export default {
  props: {
    zIndex: {
      type: Number,
      default: 1
    },
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    curTime: {
      type: String,
      default: ''
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.hasAnimation = true
        setTimeout(() => {
          this.hasAnimation = false
        }, 500)
      }
    }
  },
  data() {
    return {
      hasAnimation: false,
      defaultIndex: 2000,
      imgUrl: '',
      creatingPoster: false,
      defaultAvatar:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2a6d240504efd7fb383d93f2e297dcb9.png'
    }
  },
  filters: {
    filterTime(str) {
      let nowTime = new Date(parseInt(str) * 1000)
      let month = nowTime.getMonth()
      let day = nowTime.getDate()
      return month + 1 + '月' + day + '日'
    }
  },
  methods: {
    bindStop() {
      this.$emit('input')
    },
    bindCatch() {},
    bindShare() {
      if (this.creatingPoster || this.hasAnimation) {
        return
      }
      let dom = document.getElementById('poster')
      if (!dom) {
        this.$toast('未加载到海报')
        this.creatingPoster = false
        return
      }
      this.$toast.loading('正在生成图片...')
      this.creatingPoster = true
      window.scrollTo(0, 0)
      setTimeout(() => {
        this.createPoster()
      }, 500)
    },
    createPoster() {
      let dom = document.getElementById('poster')
      html2canvas(dom, {
        backgroundColor: null,
        useCORS: true
      })
        .then((canvas) => {
          this.$toast.clear()
          this.imgUrl = canvas.toDataURL()
          this.$toast('图片已生成')
          this.shareFriend()
        })
        .catch((err) => {})
        .finally(() => {
          this.creatingPoster = false
        })
    },
    //分享微信好友
    shareFriend() {
      let obj = {
        shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
        contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
        // 分享的数据
        shareData: {
          data: this.imgUrl, //分享的链接
          //分享的数据的格 式
          //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
          type: 'base64',
          desc: '',
          title: '#betterWE星球喝水#',
          thumbnail:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2a6d240504efd7fb383d93f2e297dcb9.png' // 分享的缩略图的url
        }
      }
      this.shareWechat(obj)
    },
    //保存图片
    handelSaveImg() {
      console.log('保存到手机成功')
      if (this.$http._isApp()) {
        this.$betterwe.onAppSaveImage({
          data: this.imgUrl, //分享的具体数据
          //分享的数据的格式
          //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
          type: 'base64'
        })
      }
    },
    //分享到微信
    shareWechat(obj) {
      if (this.$http._isApp()) {
        this.$betterwe.onAppShare(obj)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.poster-fixed {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.poster-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.scale-animation {
  animation: myscale 0.5s ease;
}

.title {
  margin: 0 auto;
  width: 266px;
  height: 48px;
  object-fit: contain;
}

.poster-mask {
  width: 319px;
  height: 425px;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 40px;
}

.poster-container {
  overflow: hidden;
}

.poster-content {
  position: relative;
  width: 319px;
  height: 425px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: space-between;

  .bg {
    left: 0;
    top: 0;
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .user {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;

    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
      object-fit: cover;
      margin-right: 10px;
    }

    .user-right {
      .nickname {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
      }

      .time {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.7);
      }
    }
  }

  .bottom {
    position: relative;
    text-align: left;
    z-index: 1;
    font-size: 40px;
    font-family: DINCondensed-Bold, DINCondensed;
    color: #000000;
    line-height: 48px;
    .num {
      font-size: 56px;
      font-family: DINCondensed-Bold, DINCondensed;
      color: rgba(0, 0, 0, 0.8);
      line-height: 35px;
      margin-bottom: 8px;
    }

    .text {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.7);
      line-height: 20px;
    }
    .bottom-right {
      margin-bottom: 24px;
    }
  }
}

.poster-bottom {
  padding: 10px 20px;
  box-sizing: border-box;
  width: 100%;
  background: #ffffff;
  border-radius: 0px 0px 10px 10px;

  .desc {
    text-align: center;
    padding: 9px 12px;
    box-sizing: border-box;
    background: #f9f9f9;
    border-radius: 8px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 17px;
    margin-bottom: 20px;
  }
}

.qrcode-content {
  display: flex;
  align-items: center;

  .logo {
    width: 45px;
    height: 45px;
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.06);
    border-radius: 14px;
    margin-right: 10px;
    object-fit: contain;
  }

  .qrcode {
    width: 60px;
    height: 60px;
    margin-left: 10px;
    object-fit: contain;
  }

  .center {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;

    .text {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 14px;
    }
  }
}

.share-btn {
  text-align: center;
  width: 319px;
  height: 44px;
  background: #6236ff;
  border-radius: 12px;
  line-height: 44px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}

.fixed-image {
  background-color: #f9f9f9;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  z-index: 999;
  object-fit: contain;
}

@keyframes myscale {
  0% {
    transform: scale(0.6);
  }

  100% {
    transform: scale(1);
  }
}
</style>
